import PropTypes from 'prop-types'
import { css } from '@emotion/react'
import Actions from 'components/App/DesktopView/shared/Composer/Header/Actions'

import { Flex } from 'shared/ui'
import Label from '../Label'
import Row from '../IndentedRow'
import Input from './Input'

const flexStyle = css`
  flex: 1 0 100%;
`

const SubjectRow = ({
  className,
  draft,
  onChange,
  onEnter,
  startInEditMode,
  subject,
  ticketId,
  shouldShowActions,
  ccVisible,
  fromVisible,
  onActionClick,
  bccVisible,
  tabIndex = '-1',
}) => {
  return (
    <Row css={flexStyle} className={className}>
      <Label>Subject:</Label>
      <Flex className="grui ml-3 flex-1">
        <Input
          subject={subject}
          draft={draft}
          onChange={onChange}
          onEnter={onEnter}
          startFocused={startInEditMode}
          ticketId={ticketId}
          tabIndex={tabIndex}
        />
      </Flex>
      {shouldShowActions && (
        <div className="grui flex actions">
          <Actions
            hideSubject
            hideCc={ccVisible}
            hideBcc={bccVisible}
            hideFrom={fromVisible}
            onClick={onActionClick}
          />
        </div>
      )}
    </Row>
  )
}

SubjectRow.propTypes = {
  draft: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
}

SubjectRow.defaultProps = {
  draft: null,
  onEnter: undefined,
}

export default SubjectRow
